import stylesheet from './Card.scss?inline';

import CustomComponent from '../../base/customComponent/CustomComponent';
import {AbstractConstructor, withLayer} from '../../base/layer/withLayer';

class NXTCard extends withLayer(CustomComponent as AbstractConstructor<CustomComponent>) {
    private rootElement: HTMLElement;

    static observedAttributes = ['interactive'];

    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    get href(): string | null {
        return this.getAttribute('href');
    }

    get target(): string | null {
        return this.getAttribute('target');
    }

    get isInteractive(): boolean {
        return this.hasAttribute('interactive');
    }

    render() {
        this.rootElement = document.createElement(this.href ? 'a' : 'div');
        this.rootElement.classList.add('card');

        if (this.href) {
            (this.rootElement as HTMLAnchorElement).href = this.href;
            if (this.target) {
                (this.rootElement as HTMLAnchorElement).target = this.target;
            }
        }

        this.rootElement.innerHTML = `
            <div class="header">
                <div class="overline"><slot name="overline"></slot></div>
                <div class="title"><slot name="title"></slot></div>
            </div>
            <div class="body"><slot></slot></div>
            <div class="footer">
                <div class="meta"><slot name="footer"></slot></div>
                <div class="action"><slot name="action"></slot></div>
            </div>
        `;

        if (this.isInteractive && !this.href) {
            this.rootElement.addEventListener('click', () => {
                this.dispatchEvent(new CustomEvent('open-overlay', {bubbles: true, composed: true}));
            });
            this.rootElement.addEventListener('keydown', (ev: KeyboardEvent) => {
                if (ev.key === 'Enter' || ev.key === ' ') {
                    ev.preventDefault();
                    this.dispatchEvent(new CustomEvent('open-overlay', {bubbles: true, composed: true}));
                }
            });
        }

        this.setHasSlottedToParent(this.rootElement);
        return this.rootElement;
    }
}

customElements.define('nxt-card', NXTCard);
